import { useEffect } from "react";

/** Sets the browser tab name for as long as the calling admin page is mounted, then restores the previous one. */
export function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
